import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import viVN from 'antd/locale/vi_VN';
import { Breadcrumb, Button, ConfigProvider, Input, Pagination, Switch, Table, TableColumnsType } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../../Layout';
import * as UnitApi from '../../../api/unit/unitApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import useToast from '../../../hook/useToast';
import ModalCreateRegion from './Modal/ModalCreateRegion';
import ModalEditRegion from './Modal/ModalEditRegion';
import { OptionSelect } from '../../../api/unit/unitApi';
import useLoading from '../../../hook/useLoading';
import { checkDisabledPermission, dataPagination, getUserPermissions } from '../../../until';
import DrawerAddvance from '../../VehicleManagement/VehicleList/Component/Drawer/DrawerAddvance';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { NodataTable } from '../../../components/NoDataTable';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { formatNumber } from '../../../services/mixin';

const Regions: React.FC = () => {
  useEffect(() => {
    document.title = 'THACO AUTO CRM';
  }, []);

  const pushToast = useToast();
  const pushLoading = useLoading();
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const [openCreateRegion, setOpenCreateRegion] = useState(false);
  const [openEditRegion, setOpenEditRegion] = useState(false);
  const [openDeleteRegion, setOpenDeleteRegion] = useState(false);
  const [dataRegions, setDataRegions] = useState<UnitApi.DataTypeRegions[]>([]);


  const [id, setId] = useState<number>();
  const [data, setData] = useState<any>();
  const [dataCreate, setDataCreate] = useState<any>();
  const [search, setSearch] = useState<string>();
  const [isOpenAddvance, setIsOpenAddvance] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  // Initialize columns as state
  let columnDefs = useMemo<ColDef<any>[]>(() =>
    [
      {
        headerName: 'Hành động',
        field: 'action',
        colId: 'action',
        width: 180,
        resizable: false,
        suppressMovable: true,
        lockPosition: 'left',
        headerComponentParams: {
          template: '<span class="w-full flex items-center justify-center">Hành động</span>'
        },
        cellRenderer: (params: ICellRendererParams) => {
          const { key } = params.data;
          return (
            <div className="h-full d-flex align-center justify-center gap-10-px">
              <EditOutlined
                className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer  ${checkDisabledPermission(edit)}`}
                onClick={() => {
                  setOpenEditRegion(true);
                  setId(Number(key));
                }}
              />
              <DeleteOutlined
                className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer  ${checkDisabledPermission(isdelete)}`}
                onClick={() => {
                  setOpenDeleteRegion(true);
                  setId(Number(key));
                }}
              />
            </div>
          );
        }
      },
      {
        headerName: 'Mã vùng miền',
        field: 'codeArea',
        colId: 'codeArea',
        flex: 1
      },
      {
        headerName: 'Tên vùng miền',
        field: 'nameArea',
        colId: 'nameArea',
        flex: 1
      },
      {
        headerName: 'Toàn quốc',
        field: 'nationwide',
        colId: 'nationwide',
        flex: 1
      },
      {
        headerName: 'Trạng thái',
        field: 'status',
        colId: 'status',
        cellRenderer: (params: ICellRendererParams) => {
          const { key, view } = params.data;
          return (
            <div className="d-flex align-center gap-10-px">
              <Switch
                defaultChecked={!!view}
                onChange={() => updateActiveRegions(Number(key))}
                className={`rs-switch rs-switch--sm  ${checkDisabledPermission(edit)}`}
              />
              <p className="font-medium fw-500 text-344054">
                {UnitApi.activeArray[view ? 1 : 0]}
              </p>
            </div>
          );
        },
        flex: 1
      }
    ], [pagination]);

  const defaultColumnsShow = ['action', 'codeArea', 'nameArea', 'nationwide', 'status'] as any;

  const getListRegions = async (pageCurent: number = 1, pageSize: number = 10, search: string = '') => {
    pushLoading(true);
    const result = await UnitApi.getListRegions(pageSize, pageCurent, search);
    if (result?.status) {
      setDataRegions(convertData(result.data));
      setPagination({ current: pageCurent, total: result.total, pageSize });
    } else {
      pushToast(result?.message, 'error', 2000);
    }
    pushLoading(false);
  };

  const reloadData = () => {
    getListRegions();
    getListOptionNationwide();
  };

  const convertData = (data: UnitApi.IRegions[]) => {
    const convertData = data.map((item) => ({
      codeArea: item.code,
      nameArea: item.title,
      nationwide: item.nationwideTitle,
      key: item.id,
      view: item.view,
    }));
    return convertData;
  };

  const updateActiveRegions = async (id: number) => {
    const result = await UnitApi.updateActiveRegions(id);
    if (result?.status) {
      getListRegions(pagination.current, pagination.pageSize);
      pushToast(result.message, 'success', 2000);
    } else {
      pushToast(result.message, 'error', 2000);
    }
  };

  const handleDelete = async () => {
    if (id) {
      const result = await UnitApi.deleteActiveNationwide(id);
      if (result?.status) {
        getListRegions(pagination.current, pagination.pageSize);
        setOpenDeleteRegion(false);
        pushToast(result.message, 'success', 2000);
        getListOptionNationwide();
      } else {
        pushToast(result.message, 'error', 2000);
      }
    }
  };

  const convertNationwide = (data: UnitApi.OptionSelect[], id: number) => {
    return data
      .filter((value) => value.value !== id)
      .map((item) => {
        const treeItem: OptionSelect = {
          value: item.value,
          label: `${item.label}`,
          title: item.title,
          children: [],
        };
        if (item.children != null && item.children.length > 0) {
          treeItem.children = convertNationwide(item.children, id);
        }
        return treeItem;
      });
  };

  const getListOptionNationwide = async () => {
    const result = await UnitApi.getListOptionNationwide();
    if (result?.status) {
      setData(UnitApi.convertRegionalValueToTree(result.data));
      setDataCreate(UnitApi.convertRegionalValueToTree(result.data));
    } else {
      pushToast(result?.message, 'error', 2000);
    }
  };

  const onPaginationChange = (current: number, pageSize: number) => {
    setPagination((prev) => ({ ...prev, current, pageSize }));
    getListRegions(current, pageSize, search);
  };

  const checkedList = localStorage.getItem('regionListColums')
    ? JSON.parse(localStorage.getItem('regionListColums') as string)
    : [...defaultColumnsShow];

  // Sử dụng colId thay vì key
  const columnDefsWithVisibility = useMemo(() => {
    return columnDefs.map((item: any) => ({
      ...item,
      hide: !checkedList.includes(item.colId) // Sử dụng hide property của AG Grid
    }));
  }, [columnDefs, checkedList]);

  const handleCloseSetting = (value: any, isChange: boolean, reorderedColumns: any[]) => {
    if (isChange) {
      localStorage.setItem('regionListColums', JSON.stringify(value));
      // Cập nhật trạng thái cột với các cột được sắp xếp lại, bảo toàn thuộc tính ẩn
      const updatedColumns = reorderedColumns.map((col) => ({
        ...col,
        hidden: !value.includes(col.colId),
      }));
      // setColumnDefs(updatedColumns);
      columnDefs = updatedColumns
    }
    setIsOpenAddvance(false);
  };

  useEffect(() => {
    getListOptionNationwide();
    getListRegions();
  }, []);

  useEffect(() => {
    if (id) {
      setData(convertNationwide(dataCreate, id));
    }
  }, [id, openEditRegion]);

  return (
    <Layout>
      <ModalCreateRegion
        getListRegions={reloadData}
        isOpen={openCreateRegion}
        closeModal={() => setOpenCreateRegion(!openCreateRegion)}
        data={dataCreate}
      />
      <ModalEditRegion
        id={id}
        data={data}
        isOpen={openEditRegion}
        getListRegions={reloadData}
        closeModal={() => setOpenEditRegion(!openEditRegion)}
      />
      <ModalDeleteManager
        isOpen={openDeleteRegion}
        onConfirm={handleDelete}
        closeModal={() => setOpenDeleteRegion(!openDeleteRegion)}
        title="Bạn có chắc chắn xóa vùng miền này"
        titleDelete="Xóa vùng miền"
        content="Vùng miền và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
      />
      <DrawerAddvance
        isOpen={isOpenAddvance}
        columns={columnDefs}
        defaultColumnsShow={defaultColumnsShow}
        localStorageValue="regionListColums"
        onClose={(value, isChange, reorderedColumns) => handleCloseSetting(value, isChange, reorderedColumns)}
        closeDrawer={() => setIsOpenAddvance(!isOpenAddvance)}
      />

      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Danh mục đơn vị</a>,
          },
          {
            title: 'Vùng miền',
          },
        ]}
      />
      <div className="title-page">Vùng miền</div>
      <div className="d-flex align-center gap-10-px pb-18-px">
        <p className="text-base font-medium text-344054 white-space-nowrap">Vùng miền</p>
        <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-1 h-8 justify-between overflow-hidden">
          <Input
            placeholder="Tìm kiếm"
            className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="border-l-F2F4F7 h-full d-flex align-center">
            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
          </div>
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          className={`rs-button rs-button--sm  ${checkDisabledPermission(add)}`}
          onClick={() => setOpenCreateRegion(true)}
        >
          Tạo mới
        </Button>
        <button
          className="border-EAECF0 bg-white rounded-2 w-8 h-8 shadow-btn-save"
          onClick={() => setIsOpenAddvance(true)}
        >
          <SettingOutlined className="text-sm text-344054" />
        </button>
      </div>

      <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
        <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
          <AgGridReact
            className="my-auto-height-grid" getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            rowData={dataRegions}
            rowHeight={55}
            columnDefs={columnDefsWithVisibility}
            rowSelection={{ mode: 'multiRow' }}
            // rowSelection="multiple"
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination showSizeChanger current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize,
                pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>
    </Layout>
  );
};

export default Regions;
